<template>
    <div class="success" v-if="getSubmitState">
        <Header></Header>
        <h1 class="text-center" v-html="getSubmitState.msg"></h1>
        <Footer></Footer>
    </div>
</template>
<script>
import Header from '../components/Header.vue'
import Baner from '../components/Baner.vue'
import Footer from '../components/Footer.vue'
import { mapGetters } from 'vuex';

export default {    
    data(){
        return {
            brand:null
        }
    },
    components:{
        Header,
        Baner,
        Footer
    },
    computed: {
        ...mapGetters([
            'getSubmitState'
        ])
    }
}
</script>
<style lang="scss">

</style>